module.exports = __webpack_public_path__ + "static/media/utility.a9c1a366.svg";